/// <reference path='../../interfaces/interfaces.d.ts' />

import { throws } from "assert";

'use strict';

class InlineEditTimeDirective {
    public restrict = 'E';
    public scope;
    public template;
    public times: String[] = [];
    public currentValue;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            mlabel: '@?',
            times: '=?',
            canEdit: '=?'
        };
        
        this.template = `
        <md-input-container class="w-100">
            <label>{{mlabel}}</label>
            <md-select class="lh-initial capital-text", ng-model="value", ng-click="edit()", ng-change="doneEdit()", ng-disabled="canEdit == false">
                <md-option class="capital-text" ng-repeat="x in times track by $index" ng-value="x">
                    {{x}}
                </md-option>
            </md-select>
        </md-input-container> 
        `;
    }
    // pass this the raw org data and this will parse it correctly HH:mm:ss format
    

    public link($scope: any, $element: any, attrs: any): any {

        var that = this;
        $scope.$watch('value', function(): any {
            let dateObj = new Date("1970-01-01T" + $scope.value);
            let momentObj = moment(dateObj).format('HH:mm');
            $scope.value = momentObj;
            $scope.times = that.generateTimes();
        });

        $scope.doneEdit = function (): any {
            // $scope.editing = false;
            var newValue: any = $scope.value;
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
            // $element.removeClass('active');
        };
    }
    public generateTimes(): any {
        var quarterHours: String[] = ['00', '15', '30', '45'];
        var times: String[] = [];
        for (var i: number = 0; i < 24; i++) {
            for (var j: number = 0; j < 4; j++) {
                var time: string = i + ':' + quarterHours[j];
                if (i < 10) {
                    time = '0' + time;
                }
                // let dateTime: any = new Date('1970-01-01T' + time);
                // let momentTime: any = moment(dateTime);
                // time = momentTime;
                times.push(time);
            }
        }
        return times;
    }

    public static DirectiveFn($timeout: any): InlineEditTimeDirective {
        return new InlineEditTimeDirective($timeout);
    }
}

InlineEditTimeDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditTime', InlineEditTimeDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_time.directive.ts